"use client";

import AlphabetPattern from '@/components/section-infographic/abc-page/Alphabetpattern';
import HeroLogo from '@/components/SectionHero/HeroLogo';
import { Logos } from '@/components/SectionHero/LogoContentTest';
// import ABCHero from "@/components/SectionHero/ABCHero";
import Image from "next/image";

const lettersArray = [
    "#logo-a",
    "#logo-t",
    "#logo-o",
    "#logo-z",
];


export default function AudiencePage() {
    return (
        <main>

            <div className="hidden md:block" >
                <HeroLogo letters={lettersArray}>
                    {Logos.AtoZ}
                </HeroLogo>
            </div>

            <h1 className='sr-only'>A to Z of Branding</h1>
            <section className="relative w-full md:hidden">
                <div className="relative w-full h-[240px] sm:h-[320px] md:h-[420px] lg:h-[80vh] section-background-filler">
                    <Image
                        src="/HeroSectionImg/AtoZ-HeroImage.svg"
                        alt="A to Z of Branding"
                        fill
                        priority
                        className="object-fill bg-none backdrop-blur-lg"
                    />
                </div>
            </section>

            {/* alphabet pattern */}
            <section className=" relative overflow-hidden">
                <div className=" ">
                    <AlphabetPattern />
                </div>

            </section>



        </main>
    );
}














